// extracted by mini-css-extract-plugin
export default {"card":"CommentHighlightCard_card__eZJiz","text":"CommentHighlightCard_text__fViIY"};